module.exports = __webpack_public_path__ + "img/mobile-neck-2_156x18.f3f0a014.png";